import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";

export default function RegisterPage() {
  const { register } = useAuth();
  const [form, setForm] = useState({ name: "", company: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const upd = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(form);
      toast.success("Account created");
      navigate("/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-5 py-16">
      <div className="flex justify-center mb-8"><Logo /></div>
      <div className="border border-slate-200 rounded-2xl bg-white p-8">
        <h1 className="font-display text-2xl font-bold text-slate-900">Create a client account</h1>
        <p className="text-sm text-slate-500 mt-1">Start submitting overseas verification cases.</p>
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="register-form">
          <div>
            <Label htmlFor="name">Full name</Label>
            <Input id="name" required value={form.name} onChange={upd("name")} data-testid="register-name-input" className="mt-1.5" />
          </div>
          <div>
            <Label htmlFor="company">Company (optional)</Label>
            <Input id="company" value={form.company} onChange={upd("company")} data-testid="register-company-input" className="mt-1.5" />
          </div>
          <div>
            <Label htmlFor="email">Work email</Label>
            <Input id="email" type="email" required value={form.email} onChange={upd("email")} data-testid="register-email-input" className="mt-1.5" />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" required minLength={6} value={form.password} onChange={upd("password")} data-testid="register-password-input" className="mt-1.5" />
            <p className="text-xs text-slate-500 mt-1">At least 6 characters.</p>
          </div>
          <Button type="submit" disabled={busy} data-testid="register-submit-btn" className="w-full pill-btn bg-[#1E3A8A] hover:bg-[#1E40AF] text-white h-11">
            {busy ? "Creating…" : "Create account"}
          </Button>
        </form>
        <p className="mt-6 text-sm text-slate-600 text-center">
          Already a user? <Link to="/login" className="text-[#1E3A8A] font-semibold hover:underline">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
